import React, {Component} from 'react';
import PropTypes from 'prop-types';
import {asyncComponent} from 'react-async-component';
import SiteFooter from '@homeaway/react-site-footer';

/* istanbul ignore next */
const AsyncSiteFooter = asyncComponent({
    name: 'AsyncSiteFooter',
    resolve: () => Promise.resolve(SiteFooter),
    serverMode: 'defer'
});

class Footer extends Component {
    static propTypes = {
        site: PropTypes.string,
        locale: PropTypes.string
    }

    static defaultProps = {
        site: 'homeaway_us',
        locale: 'en_US_HA'
    }

    shouldComponentUpdate(nextProps) {
        // Prevent multiple API calls
        return nextProps.site !== this.props.site && nextProps.locale !== this.props.locale;
    }

    render() {
        const {site, locale, ...rest} = this.props;
        return (
            <AsyncSiteFooter
                dataUrl="/traveler/scratchpad/api/footer"
                site={site}
                locale={locale}
                {...rest}
            />
        );
    }
}

export default Footer;



// WEBPACK FOOTER //
// ./src/universal/components/Footer/Footer.js